export default class SampleTypeWriteDTO {

    public id: number;
    public name: string;
    public depIntroText: string;
    public defaultWeight: number | null;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.name = data['name'];
        this.depIntroText = data['depIntroText'] || '';
        this.defaultWeight = data['defaultWeight'] || null;
    }
}